var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button-more") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-100.0%",
    y: "-100.0%",
    width: "300.0%",
    height: "300.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.10432146 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-&-pop-up-&-button",
    transform: "translate(-239.000000, -1488.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-more",
    transform: "translate(259.000000, 1508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    cx: 15,
    cy: 15,
    r: 14.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.3636364,20 L16.1294545,19.2718313 L21.8185713,13.8536248 C22.3350912,13.3617012 22.3967574,12.5591577 21.9614545,11.9940975 C21.5806274,11.4997512 20.8711592,11.4077259 20.376813,11.788553 C20.3455624,11.8126274 20.315594,11.8383218 20.287031,11.8655308 L15.3636364,16.55552 L15.3636364,16.55552 L10.4402417,11.8655308 C9.98840915,11.4351184 9.27320828,11.4524829 8.8427959,11.9043155 C8.81558697,11.9328785 8.78989254,11.9628469 8.76581818,11.9940975 C8.33051535,12.5591577 8.39218156,13.3617012 8.90870142,13.8536248 L14.5978182,19.2718313 L14.5978182,19.2718313 L15.3636364,20 Z",
    id: "Shape",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonMore);
export default __webpack_public_path__ + "static/media/button-more.3de2d9a240c81884950a69dde3854003.svg";
export { ForwardRef as ReactComponent };